import { FC } from 'react';

import errorImage from '@/assets/form-images/form-error.svg';
import Image from '@/components/image';
import ModalContent from '@/components/lottery-form/modals/content';
import getVariablePlainText from '@/lib/get-variable-plain-text';
import useVariables from '@/lib/hooks/use-variables';

interface ErrorModalContentProps {
  titleSlug?: string;
  textSlug?: string;
}

const ErrorModalContent: FC<ErrorModalContentProps> = ({
  titleSlug = 'form-error-title',
  textSlug = 'form-error-text',
}) => {
  const variables = useVariables();
  const title = getVariablePlainText(variables[titleSlug]);
  const text = variables[textSlug];

  return (
    <ModalContent
      image={
        <Image
          src={errorImage.src}
          alt="Participation not successful"
          className="aspect aspect-2-1"
        />
      }
      title={title}
      text={text}
    />
  );
};

export default ErrorModalContent;
